module.exports = __webpack_public_path__ + "img/progressico.2068b250.png";